module.exports = __webpack_public_path__ + "static/media/jobSpotScreenShot.57a58adc.png";